import { readRuleSnapshot } from "./ruleSnapshot";
import { normalizePricingModel } from "./pricingModelVocabulary";

export {
  PRICING_MODELS,
  type PricingModel,
  normalizePricingModel,
  isDirectFunded,
  isSubscription,
} from "./pricingModelVocabulary";

/** Modèle d'un compte. Le snapshot fait autorité : il fige le modèle au moment
 *  de l'achat, et createAccount ne pose pas propFirmAccountTypeId. Le type de
 *  compte lié sert de repli (comptes importés depuis Tradovate, et snapshots
 *  antérieurs au 2026-09-29 qui ne portent pas encore la clé pricingModel).
 *  Point d'entrée UNIQUE : toujours lire le modèle via cette fonction, jamais
 *  via `resolveRules(...).accountType.pricingModel`, qui vaut null pour un
 *  snapshot sans cette clé. */
export function accountPricingModel(account: {
  ruleSnapshot?: unknown;
  propFirmAccountType?: { pricingModel?: string | null } | null;
}) {
  const snapshot = readRuleSnapshot(account.ruleSnapshot);
  if (snapshot?.pricingModel) return normalizePricingModel(snapshot.pricingModel);
  return normalizePricingModel(account.propFirmAccountType?.pricingModel);
}
